// Define mapping lists
const days_short = ["", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const days_long = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const months_numerical = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
const months_short = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const months_long = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];



// Format datetime in local timezone
export function format_datetime(datetime) {
  try {
    var datetime = new Date(datetime);
    var currentDatetime = new Date();
    var day = days_long[datetime.getDay()];
    var month = months_short[datetime.getMonth()];
    var date = datetime.getDate();
    var year = datetime.getFullYear();

    var hour = datetime.getHours() < 12 ? datetime.getHours() : datetime.getHours() - 12;
    var minutes = datetime.getMinutes() >= 10 ? datetime.getMinutes() : "0" + datetime.getMinutes();
    var am_pm = datetime.getHours() < 12 ? "am" : "pm";

    // Check if date is today or tomorrow
    if ((datetime.getDate() === currentDatetime.getDate()) &&
      (datetime.getMonth() === currentDatetime.getMonth()) &&
      (datetime.getFullYear() === currentDatetime.getFullYear())) {
      var value = "Today, " + hour + ":" + minutes + " " + am_pm;
    } else if ((datetime.getDate() === (currentDatetime.getDate() + 1)) &&
      (datetime.getMonth() === currentDatetime.getMonth()) &&
      (datetime.getFullYear() === currentDatetime.getFullYear())) {
      var value = "Tomorrow, " + hour + ":" + minutes + " " + am_pm;
    } else {
      var value = day + ", " + month + " " + date + ", " + (datetime.getYear() !== currentDatetime.getYear() ? year + ", " : "") + hour + ":" + minutes + " " + am_pm;
    }

    return value;
  } catch (error) {
    console.log(error);
  }
  return false;
}



// Format date in local timezone
export function format_date(datetime, forcedate=false, forceyear=false) {
  try {
    var datetime = new Date(datetime);
    var currentDatetime = new Date();
    var day = days_long[datetime.getDay()];
    var month = months_short[datetime.getMonth()];
    var date = datetime.getDate();
    var year = datetime.getFullYear();

    // Check if date is today or tomorrow
    if (!forcedate && 
      (datetime.getDate() === currentDatetime.getDate()) &&
      (datetime.getMonth() === currentDatetime.getMonth()) &&
      (datetime.getFullYear() === currentDatetime.getFullYear())) {
      var value = "Today";
    } else if (!forcedate && (datetime.getDate() === (currentDatetime.getDate() + 1)) &&
      (datetime.getMonth() === currentDatetime.getMonth()) &&
      (datetime.getFullYear() === currentDatetime.getFullYear())) {
      var value = "Tomorrow";
    } else {
      var value = day + ", " + month + " " + date + ((datetime.getYear() !== currentDatetime.getYear() || forceyear) ? ", " + year : "");
    }

    return value;
  } catch (error) {
    console.log(error);
  }
  return false;
}



// Format date in local timezone
export function format_month_year(datetime) {
  try {
    var datetime = new Date(datetime);
    var currentDatetime = new Date();
    var month = months_short[datetime.getMonth()];
    var year = datetime.getFullYear();

    // Format
    var value = month + ", " + year;

    return value;
  } catch (error) {
    console.log(error);
  }
  return false;
}



// Format date in local timezone
export function format_date_technical(datetime) {
  try {
    var datetime = new Date(datetime);
    var value = datetime.getFullYear() + "-" + months_numerical[datetime.getMonth()] + "-" + datetime.getDate();

    return value;
  } catch (error) {
    console.log(error);
  }
  return false;
}



// Format time in local timezone
export function format_time(datetime) {
  try {
    var datetime = new Date(datetime);
    var hour = datetime.getHours() < 12 ? datetime.getHours() : datetime.getHours() - 12;
    var minutes = datetime.getMinutes() >= 10 ? datetime.getMinutes() : "0" + datetime.getMinutes();
    var am_pm = datetime.getHours() < 12 ? "am" : "pm";

    var value = hour + ":" + minutes + " " + am_pm;

    return value;
  } catch (error) {
    console.log(error);
  }
  return false;
}



// Format price
export function format_price(price, currency = "USD") {
  try {
    return `${currency} ${price.toFixed(2)}`;;
  } catch (error) {
    console.log(error);
  }
  return false;
}